<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M20.635 6.321a5.713 5.713 0 00-5.846 8.032c.196.434.103.943-.233 1.28L6.66 23.527a1.281 1.281 0 101.812 1.812l7.896-7.896a1.143 1.143 0 011.279-.233 5.713 5.713 0 008.032-5.846l-2.939 2.939a2.285 2.285 0 01-3.2 0l-.008-.008-1.836-1.837a2.285 2.285 0 010-3.199l.008-.008 2.931-2.93zM18.56 4.13a7.998 7.998 0 014.731.581 1.143 1.143 0 01.337 1.85l-4.3 4.299 1.812 1.812 4.3-4.3a1.143 1.143 0 011.849.337 7.998 7.998 0 01-9.834 10.88l-7.367 7.366a3.566 3.566 0 11-5.043-5.043l7.367-7.367A8 8 0 0118.56 4.13z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsToolOutline'
}
</script>
